import { css } from '@emotion/css'
import { theme, expandFontTheme } from '@contrast-security-inc/design-system-foundations'

export const parentLabelCss = css`
  > label {
    ${expandFontTheme(theme.font.bodyStrong)}
    text-transform: capitalize;
    color: ${theme.color.black} !important;
  }
`
